import { ref } from 'vue'

export interface ConfirmOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  showCancel?: boolean
  destructive?: boolean
}

interface ConfirmState {
  show: boolean
  title: string
  message: string
  confirmText: string
  cancelText: string
  showCancel: boolean
  destructive: boolean
  resolve: ((value: boolean) => void) | null
}

const state = ref<ConfirmState>({
  show: false,
  title: 'Confirm Action',
  message: 'Are you sure you want to continue?',
  confirmText: 'OK',
  cancelText: 'Cancel',
  showCancel: true,
  destructive: false,
  resolve: null
})

export function useConfirm() {
  function showConfirm(options: ConfirmOptions): Promise<boolean> {
    // If there's a pending dialog, resolve it as cancelled
    if (state.value.resolve) {
      state.value.resolve(false)
    }

    state.value = {
      show: true,
      title: options.title || 'Confirm Action',
      message: options.message,
      confirmText: options.confirmText || 'OK',
      cancelText: options.cancelText || 'Cancel',
      showCancel: options.showCancel !== undefined ? options.showCancel : true,
      destructive: options.destructive || false,
      resolve: null
    }

    return new Promise<boolean>((resolve) => {
      state.value.resolve = resolve
    })
  }



  function closeConfirm(result: boolean) {
    if (state.value.resolve) {
      state.value.resolve(result)
      state.value.resolve = null
    }
    state.value.show = false
  }

  function handleEscape(event: KeyboardEvent) {
    if (event.key === 'Escape' && state.value.show) {
      closeConfirm(false)
    } else if (event.key === 'Enter' && state.value.show) {
      event.preventDefault()
      closeConfirm(true)
    }
  }

  return {
    state,
    showConfirm,
    confirm: closeConfirm, // Used by ConfirmDialog component to close the dialog
    handleEscape
  }
}

